export const OwaFeatureFlagsButtonID: string = 'owaFeatureFlagsButton';
export const OwaPremiumButtonID: string = 'owaPremiumButton';
export const OwaTimePanelButtonID: string = 'Time';
export const OwaSettingsButtonID: string = 'owaSettingsButton';
export const OwaFeedbackButtonID: string = 'owaFeedbackButton';
export const OwaWhatsNewButtonID: string = 'whatsnew';
export const OwaHelpButtonID: string = 'owahelp';
export const OwaActivityFeedButtonID: string = 'owaActivityFeedButton';

export const OwaFeatureFlagsFlexPaneID: string = 'OwaFeatureFlags';
export const OwaPremiumFlexPaneID: string = 'owaPremiumButton';
export const OwaTimePanelFlexPaneID: string = 'OwaTimePanel';
export const OwaSettingsFlexPaneID: string = 'OwaSettings';
export const OwaFeedbackFlexPaneID: string = 'OwaFeedback';
export const OwaWhatsNewFlexPaneID: string = 'whatsNewPane';
export const OwaHelpFlexPaneID: string = 'OwaHelp';
export const OwaActivityFeedFlexPaneID: string = 'OwaActivityFeed';
export const OwaExpressionFlexPaneID: string = 'Expressions';
export const OwaSkypeFlexPaneID: string = 'Skype';
